import React from 'react';
const LogoPrideMobile = () => {
  return (
    <svg id="LogoPrideMobile" xmlns="http://www.w3.org/2000/svg" version="1.1" x="0px" y="0px" viewBox="0 0 2400 240">
      <title id="zillowLogo">Zillow Mobile Pride Logo</title>
      <path
        className="st0"
        d="M2324.3,129.6h-84.5c0.5,21.1,13.5,33.4,34.3,33.4c14.4,0,24.4-5.7,28.9-16.1h20.6
	c-3.8,20.1-23.9,34.1-49.5,34.1c-33.6,0-54.7-22.2-54.7-57.5c0-34.6,21.3-57.3,53.7-57.3c30.8,0,51.6,21.3,51.6,51.3
	C2324.8,121.6,2324.7,125.6,2324.3,129.6z M2304.7,113.8c0-19.2-11.8-31-31.7-31s-32.2,12.5-33.1,31H2304.7z"
      />
      <path
        className="st0"
        d="M1844.8,67.8h20.6V88c5.9-14,19.2-23,38.2-23c26.8,0,40.5,15.6,40.5,44.8v67.3h-20.4v-58.3
	c0-24.4-8.1-36-27.5-36c-20.4,0-30.8,14.4-30.8,36.5v57.8h-20.6V67.8z"
      />
      <path
        className="st0"
        d="M1705.9,122.7c0-32.3,20.7-57.8,54.7-57.8c17.4,0,31.6,8.8,38.5,22.3V67.8h20.4v109.6h-20.4v-19.2
	c-6.9,13.6-22.6,22.1-39,22.1C1725.2,180.2,1705.9,155,1705.9,122.7z M1800,122.7c0-21.2-13.1-39.2-37.1-39.2
	c-22.6,0-36.6,16.6-36.6,39.2c0,22.3,14,39,36.6,39C1787,161.6,1800,143.8,1800,122.7L1800,122.7z"
      />
      <path
        className="st0"
        d="M1959.2,122.7c0-32.3,20.7-57.8,54.7-57.8c17.3,0,31.6,8.8,38.5,22.3V67.8h20.4v109.6h-20.4v-19.2
	c-6.9,13.6-22.6,22.1-39,22.1C1978.5,180.2,1959.2,155,1959.2,122.7z M2053.3,122.7c0-21.2-13.1-39.2-37.1-39.2
	c-22.6,0-36.6,16.6-36.6,39.2c0,22.3,14,39,36.6,39C2040.3,161.6,2053.3,143.8,2053.3,122.7z"
      />
      <path
        className="st0"
        d="M658.8,67.4h35l10.1,33.2c3.4,11,6.3,21.3,9.1,31.8h0.4c2.9-10.2,5.9-21.2,9.2-31.8l10.6-33.1h25.8l10.5,33.1
	c3.5,11.4,6.2,21.3,9,31.8h0.5c2.7-10.5,5.7-20.7,9.1-31.8l10.2-33.2h32.5L795.6,177h-32l-8.7-27.5c-3.3-10.8-6.5-21.8-9.3-31.9
	h-0.4c-2.7,10.1-5.9,20.7-9.5,31.7l-8.9,27.7h-32.6L658.8,67.4z"
      />
      <rect x="423.3" y="9.5" className="st0" width="35.4" height="167.4" />
      <rect x="484.9" y="9.5" className="st0" width="35.4" height="167.4" />
      <path
        className="st0"
        d="M537.9,122.6c0-33.3,26.8-57.9,59.7-57.9c32.5,0,59.4,24.7,59.4,57.9s-26.8,58.1-59.4,58.1
	C564.7,180.6,537.9,155.9,537.9,122.6 M623,122.6c0-16.3-11.6-27.4-25.4-27.4c-14.1,0-25.7,11.1-25.7,27.4s11.6,27.4,25.7,27.4
	C611.3,150,623,139,623,122.6"
      />
      <polygon
        className="st0"
        points="218.5,25 218.5,57.3 281,57.3 281.3,57.7 216.6,167.7 216.6,176.9 338.5,176.9 338.5,144.7
	270.8,144.7 270.5,144.3 335.2,34.4 335.1,34.4 335.1,25 "
      />
      <path
        className="st0"
        d="M378.7,12.5c11,0,20,8.8,20.2,19.9c0,11.1-9,20.2-20.2,20.2s-20.2-9-20.2-20.2
	C358.7,21.4,367.7,12.5,378.7,12.5 M361,67.4h35.4V177H361V67.4z"
      />
      <path
        className="st0"
        d="M853.5,51.3c0.1-2.8-2-5.2-4.8-5.3c-0.1,0-0.3,0-0.4,0h-5.7v15.3h2.5v-4.6h2.5l2.8,4.6h2.8l-3-5
	C852.3,55.5,853.6,53.5,853.5,51.3z M848.1,54.5h-3v-6.2h3c1.7,0.1,3,1.6,2.9,3.3C850.9,53.1,849.7,54.4,848.1,54.5z"
      />
      <path
        className="st0"
        d="M847.5,40.7c-7.3,0-13.3,5.9-13.3,13.2c0,7.3,5.9,13.3,13.2,13.3c7.3,0,13.3-5.9,13.3-13.2l0,0
	C860.7,46.6,854.8,40.7,847.5,40.7L847.5,40.7z M847.5,64.7c-5.9,0-10.7-4.8-10.7-10.7s4.8-10.7,10.7-10.7c5.9,0,10.7,4.8,10.7,10.7
	l0,0C858.2,59.8,853.4,64.6,847.5,64.7L847.5,64.7z"
      />
      <path
        className="st0"
        d="M1530.2,25.3h22.5l54.6,121.3l54.6-121.3h22.3v151.7h-20.4V69.7l-48.2,107.2h-16.4l-48.4-108v108h-20.4
	L1530.2,25.3z"
      />
      <path
        className="st0"
        d="M2202.4,67.8v107.4c0,21-6.7,36.8-19.1,46.4c-9.3,6.9-22.2,10.3-38,10.3c-15.1,0-29.2-3.6-39.2-10.8
	c-9.8-6.9-15.8-17.2-16.3-29.2h21.8c1.4,12.9,12.4,22.5,33.5,22.5c23.9,0,36.8-11.5,36.8-37.8v-17.9c-6.9,13.9-23.2,22.2-39.2,22.2
	c-33.7,0-54.5-25.4-54.5-57.9c0-32.8,22.2-58.1,55-58.1c17,0,31.8,8.4,38.7,22.5V67.8H2202.4z M2182.8,123
	c0-21.8-14.1-39.5-37.3-39.5c-22,0-36.8,16.7-36.8,39.5c0,22.5,15.1,39.2,36.8,39.2C2168.7,162.2,2182.8,144.5,2182.8,123z"
      />
      <path
        className="st0"
        d="M2346.3,67.6h20.8v24.1c4.3-18.7,18.4-26.8,32.3-26.8c3.4-0.1,6.8,0.3,10.1,1V85c-3.4-0.6-6.9-0.8-10.3-0.7
	c-21.8,0-32.1,19.9-32.1,44.5v48.1h-20.8V67.6z"
      />
      <path
        className="st0"
        d="M1098.1,129.6h-84.5c0.5,21.1,13.5,33.4,34.3,33.4c14.4,0,24.4-5.7,28.9-16.1h20.6
	c-3.8,20.1-23.9,34.1-49.4,34.1c-33.6,0-54.7-22.2-54.7-57.5c0-34.6,21.3-57.3,53.7-57.3c30.8,0,51.6,21.3,51.6,51.3
	C1098.6,121.6,1098.5,125.6,1098.1,129.6z M1078.4,113.8c0-19.2-11.8-31-31.7-31s-32.2,12.5-33.1,31H1078.4z"
      />
      <path
        className="st0"
        d="M1117.8,67.8h20.6V88c5.9-14,19.2-23,38.2-23c26.8,0,40.5,15.6,40.5,44.8v67.3h-20.4v-58.3
	c0-24.4-8.1-36-27.5-36c-20.4,0-30.8,14.4-30.8,36.5v57.8h-20.6L1117.8,67.8z"
      />
      <path
        className="st0"
        d="M1298.4,158.2v18.2c-6.1,1.2-12.3,1.7-18.5,1.6c-12.8,0-33.4-2.4-33.4-37.6V84.8h-19.7V67.6h19.7V33h20.6v34.6
	h27.4v17.3h-27.4V136c0,20.8,7.1,23.7,17.5,23.7C1289.2,159.6,1293.8,159.1,1298.4,158.2z"
      />
      <path
        className="st0"
        d="M1309.3,122.7c0-32.3,20.7-57.8,54.7-57.8c17.3,0,31.6,8.8,38.5,22.3V67.8h20.4v109.6h-20.4v-19.2
	c-6.9,13.6-22.6,22.1-39,22.1C1328.5,180.2,1309.3,155,1309.3,122.7z M1403.4,122.7c0-21.2-13.1-39.2-37.1-39.2
	c-22.6,0-36.6,16.6-36.6,39.2c0,22.3,14,39,36.6,39C1390.3,161.6,1403.4,143.8,1403.4,122.7z"
      />
      <path className="st0" d="M1447.9,25.3h20.6v152h-20.6V25.3z" />
      <path
        className="st0"
        d="M951.1,125.5c20.1-6.9,34-25.2,34-48.6c0-30.2-22.8-51.7-52.1-51.7h-61v152.1h21.3v-48.6h34.8l30.2,48.6h24.6
	L951,125.7L951.1,125.5z M893.3,44.5h36.8c18.4,0,33.7,12.5,33.7,32.4c0,19.7-15.3,32.2-33.7,32.2h-36.8V44.5z"
      />
      <g>
        <path className="st1" d="M161.1,89.7v-26l-19.3-15.3V94C149.3,92.1,156,90.6,161.1,89.7z" />
        <path
          className="st0"
          d="M121.4,61.2c1.4,1.8,2.7,3.2,3.4,4.1c0.3,0.4,0.3,1-0.1,1.3c0,0-0.1,0.1-0.1,0.1c-1,0.8-2.1,1.6-3.1,2.5v30.4
		c7-2,14-4,20.4-5.6V48.4l-20.4-16.1V61.2z"
        />
        <path className="st2" d="M100.9,105.9c6.6-2.2,13.5-4.3,20.4-6.3V69.2c-6.8,5.5-13.8,11.7-20.4,18.1V105.9z" />
        <path
          className="st2"
          d="M108.9,47.7c0.8-0.2,1.2,0.1,1.7,0.6c2,2.2,7.1,8.4,10.8,12.9v-29l-20.4-16.1V50
		C103.8,49.1,106.5,48.3,108.9,47.7z"
        />
        <path className="st3" d="M80.5,108.6v4.4c5.7-2.2,12.8-4.7,20.4-7.2V87.3C93.3,94.5,86.2,102,80.5,108.6z" />
        <path className="st3" d="M100.9,49.9V16L80.6,0l-0.2,0.1v56.6C87.9,54,94.9,51.7,100.9,49.9z" />
        <path
          className="st4"
          d="M75.3,114.9c-0.2,0.3,0,0.3,0.1,0.3c1.5-0.7,3.2-1.3,5-2v-4.4C78.6,110.8,76.9,112.9,75.3,114.9z"
        />
        <path className="st4" d="M80.5,56.7V0.1L60,16.3v48.1C67,61.6,73.9,59,80.5,56.7z" />
        <path className="st5" d="M60,64.4V16.3L39.6,32.4v40.4C46.2,69.9,53.2,67.1,60,64.4z" />
        <path className="st6" d="M39.6,32.4L19.1,48.6v33.5c6.3-3,13.3-6.2,20.4-9.3V32.4z" />
        <path className="black" d="M0,63.6v28.5c5.2-3.1,11.7-6.5,19.1-10V48.5L0,63.6z" />
        <path className="st1" d="M161.1,177v-58.5c-4.7,0.8-11.4,2.3-19.3,4.4V177H161.1z" />
        <path className="st0" d="M121.4,177h20.4v-54.2c-6.2,1.6-13.1,3.5-20.4,5.7V177z" />
        <path className="st2" d="M100.9,134.8V177h20.4v-48.5C114.7,130.4,107.8,132.5,100.9,134.8z" />
        <path className="st3" d="M80.5,141.7V177h20.4v-42.1C94,137,87.1,139.4,80.5,141.7z" />
        <path className="st4" d="M60,149.6V177h20.4v-35.2C73.3,144.3,66.3,147,60,149.6z" />
        <path
          className="st4"
          d="M77.2,82.7c0.3-0.2,0.2-0.4-0.1-0.3C73,83.7,67,86,60,88.8V98C66.2,91.8,72.1,86.4,77.2,82.7z"
        />
        <path className="st5" d="M60,88.8c-6.3,2.5-13.3,5.5-20.4,8.6v23.3C45.9,113,53.1,105,60,98V88.8z" />
        <path
          className="st5"
          d="M43.4,157.1c-0.6,0.4-1.3,0.3-1.7-0.3l-2.2-2.6V177H60v-27.4C53.8,152.1,48.2,154.7,43.4,157.1z"
        />
        <path
          className="st6"
          d="M26.7,139c-0.4-0.5-0.5-0.7,0.1-1.5c3.4-5,7.8-10.8,12.8-16.8V97.4c-7,3-14.1,6.2-20.4,9.2V177h20.4v-22.7
		L26.7,139z"
        />
        <path className="black" d="M0,116.1v60.8h19.1v-70.4C11.4,110.2,4.6,113.5,0,116.1z" />
      </g>
    </svg>
  );
};

export default LogoPrideMobile;
